import React from 'react';

/**
 * A clinician's CScore history as a bare inline sparkline.
 *
 * Plain SVG rather than Recharts: there is one of these per clinician and a
 * clinic can carry thirty, so a full chart runtime each would cost far more
 * than the marks are worth. No axes or labels — the number beside it carries
 * the value, this carries the shape.
 *
 * Every sparkline in a group is drawn on the SAME y-domain, passed in by the
 * parent. Per-sparkline autoscaling would make a clinician who drifted three
 * points look identical to one who fell ninety.
 */
export default function TrendSparkline({ points, color, domain, width = 96, height = 28 }) {
  if (!points || points.length === 0) return null;

  const pad = 3;
  const [min, max] = domain;
  const span = max - min || 1;

  const x = (i) => points.length === 1
    ? width / 2
    : pad + (i / (points.length - 1)) * (width - pad * 2);
  const y = (score) => height - pad - ((score - min) / span) * (height - pad * 2);

  const path = points.map((p, i) => `${i === 0 ? 'M' : 'L'} ${x(i).toFixed(1)} ${y(p.score).toFixed(1)}`).join(' ');
  const lastX = x(points.length - 1);
  const lastY = y(points[points.length - 1].score);

  return (
    <svg width={width} height={height} className="overflow-visible" aria-hidden="true">
      {points.length > 1 && (
        <path d={path} fill="none" stroke={color} strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
      )}
      {/* Surface ring keeps the end point legible where it lands on the line. */}
      <circle cx={lastX} cy={lastY} r={3.5} fill={color} stroke="#ffffff" strokeWidth={2} />
    </svg>
  );
}
